export default "__VITE_ASSET__BcM3qsZw__"